module.exports = __webpack_public_path__ + "img/light_candle.6a2592b1.png";